import React, {useContext, useState, useEffect }from 'react'
import { AppContext } from "../../App.js";
import { NavLink, Link } from 'react-router-dom';

//Import Css
import './developComponent.css'

//Import FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleDown, faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

//Import Assets
import LogoWebmedia from '../../assets/homeAssets/logoWebMedia.svg'
import photoDevelopScreen1 from '../../assets/developAssets/photoDevelopScreen-1.svg'
import photoDevelopScreen2 from '../../assets/developAssets/photoDevelopScreen-2.svg'
import photoDevelopScreen3 from '../../assets/developAssets/photoDevelopScreen-3.svg'
import photoDevelopScreen4 from '../../assets/developAssets/photoDevelopScreen-4.svg'

//Import Component
import { DevelopScreenCompt } from '../developComponent/developScreenCompt' 
import { InfoDevelopComponent } from '../home/infoDevelopComponent/infoDevelopComponent'
import { PlanesCompt } from './planesCompt/planesCompt' 
import { FooterComponent } from '../footerComponent/footerComponent'
import { BarraMenuDown } from '../home/barraMenuDown';
import { PanelMenuSlideDV } from '../developComponent/panelMenuSlideDV';


export function DevelopComponent() {


    const {

    //Panel Menu Slide Dv
      openMenuSlideDv,
      setOpenMenuSlideDv,
      valorScreenDv,
      setValorScreenDv

    } = useContext(AppContext);


    return(

        <div className='container-all-dv-component' translate="no">

                <BarraMenuDown />

               <PanelMenuSlideDV
               
                activeMenu='desarrollo-web'
               
               />

            <div className='container-sections-dv'>

                <div className='box-btn-slide-logo-dv'>

                    <div className='box-btn-menu-slide-dv'>

                        <button className="btn-menu-slide-dv" onClick={() => setOpenMenuSlideDv(!openMenuSlideDv)}>
                            
                            <span id='btn-slide-menu-open-dv' className="material-symbols-outlined">menu</span>
                            
                        </button>

                    </div>


                    <div className='box-logo-webmedia-dv'>

                        <img className='logo-webmedia-dv' src={LogoWebmedia} alt="Logo WebMedia"/>

                    </div>

                </div>


                <div className='box-slide-develop' key={valorScreenDv}>

                    {(() => 
                        
                    { switch (valorScreenDv)
                    
                    { case 0: return ( 
                    
                            <DevelopScreenCompt 
                                comptInfo={ 
                                    <InfoDevelopComponent 
                                        titleInfoDevelop={<> DESARROLLO WEB <br /> PROFESIONAL </>} 
                                        textInfoDevelop="Desarrollamos sitios webs corporativos con lenguajes de programación 
                                        nativos 100% responsivos a todos los dispositivos móviles y navegadores webs modernos." 
                                        photIconDev={[0,1,2,3]}
                                    /> }  

                                photoInfoScreen={photoDevelopScreen1} 
                            /> ); 

                    case 1: return ( 
                    
                            <DevelopScreenCompt 
                                comptInfo={ 
                                    <InfoDevelopComponent 
                                        titleInfoDevelop={<> DISEÑO MÓVIL <br /> 100% RESPONSIVO </>} 
                                        textInfoDevelop="Su sitio web con diseño móvil responsivo, totalmente compatible y optimizado 
                                        a todos los tamaños de pantalla y navegadores webs modernos que garantizan una experiencia de 
                                        navegación fluida y nativa." 
                                        photIconDev={[4,5,6,7]} 
                                    /> } 

                                photoInfoScreen={photoDevelopScreen2} 

                            /> );


                    case 2: return ( 
                    
                            <DevelopScreenCompt 
                                comptInfo={ 
                                    <InfoDevelopComponent 
                                        titleInfoDevelop={<> SEO CON IA Y <br /> MOTORES DE BÚSQUEDA </>} 
                                        textInfoDevelop="Optimizamos el contenido e información de su web en motores 
                                        de búsqueda y modelos IA para maximizar oportunidades de venta y recomendación." 
                                        photIconDev={[8,9,10,11]} 
                                    /> } 

                                photoInfoScreen={photoDevelopScreen3} 

                            /> );



                    case 3: return ( 
                    
                            <DevelopScreenCompt 
                                comptInfo={ 
                                    <InfoDevelopComponent 
                                    titleInfoDevelop={<> SU WEB EN GOOGLE </>} 
                                    textInfoDevelop="Optimizamos su sitio para motores de búsqueda y modelos IA.
                                    Todo el contenido e información de sus productos, servicios, ubicaciones y 
                                    canales de información será registrado e indexado en las principales 
                                    herramientas de posicionamiento y búsqueda de Google." 
                                    photIconDev={[12,13,14,15]} 
                                /> } 
                                photoInfoScreen={photoDevelopScreen4} 
                            /> );


                    case 4: return ( 
                    
                        <PlanesCompt />
                    
                    );



                    default: return null; } 
                
                        })()
                    
                    }



                </div>


                <div className='box-btn-menu-develop'>


                    <div className='box-icon-menu-develop'>

                        <span className={`material-symbols-outlined ms-dv ${valorScreenDv === 0 ? 'ms-dv0' : ''}`} onClick={() => setValorScreenDv(0)}>check_box_outline_blank</span>
                        <span className={`material-symbols-outlined ms-dv ${valorScreenDv === 1 ? 'ms-dv1' : ''}`} onClick={() => setValorScreenDv(1)}>check_box_outline_blank</span>
                        <span className={`material-symbols-outlined ms-dv ${valorScreenDv === 2 ? 'ms-dv2' : ''}`} onClick={() => setValorScreenDv(2)}>check_box_outline_blank</span>
                        <span className={`material-symbols-outlined ms-dv ${valorScreenDv === 3 ? 'ms-dv3' : ''}`} onClick={() => setValorScreenDv(3)}>check_box_outline_blank</span>
                        <span className={`material-symbols-outlined ms-dv md-planes ${valorScreenDv === 4 ? 'ms-dv4' : ''}`} onClick={() => setValorScreenDv(4)}>check_box_outline_blank</span>

                    </div>


                </div>


            </div>

            {/* SECTION PLANES Y PRECIO V. MOBILE */}
            <div className='box-planes-compt-mobile'>

                    <PlanesCompt />

            </div>

            {/* SECTION FOOTER DEVELOP */}
             <div className='container-footer-mobile'>

                <FooterComponent />

            </div>



        </div>


    );
}



    {/* 

    <span class="material-symbols-outlined">
    check_box_outline_blank
    </span> */}



    {/* --------- PANEL MENU SLIDE ----------- */}
    {/* <div className={`style-panel-menu-slide panel-menu-slide-${panelIsOpen ? 'open' : 'close'}`}>

            <div className="box-logo-panel-slide">

                    <img className='logo-webmedia-panel-slide' src={LogoWebmedia} alt="Logo WebMedia"/>

            </div>

        <nav className="conteiner-links-panel-slide">

            <NavLink to='/desarrollo-web'        className={`home-menu-link slide-link-1`}>Desarrollo Web</NavLink>
            <NavLink to='/google-ads'            className={`home-menu-link slide-link-2`}>Google ADS</NavLink>
            <NavLink to='/email-marketing'       className={`home-menu-link slide-link-3`}>Email Marketing</NavLink>
            <NavLink to='/soporte-empresas'      className={`home-menu-link slide-link-4`}>Soporte Empresas</NavLink>
            <NavLink to='/contacto'              className={`home-menu-link slide-link-4`}>Contacto   </NavLink>

        </nav>

    </div> */}
